<script>
export default {
    inserted: function(el) {
        let popups = el.querySelectorAll('.popup');
        let images = el.querySelectorAll('.image');

        let setOnclick = function(ctl, id) {
            ctl.onclick = function() {
                for(let i = 0; i < images.length; i++) {
                    popups[i].classList.remove('active');
                }
                popups[id].classList.add('active');
                return false;
            }
        }

        for(let i = 0; i < images.length; i++) {
            setOnclick(images[i], i);
        }

        let setOnclickPopups = function(element) {
            element.onclick = function () {
                hidePopUps();
            }
        }

        for(let popup of popups) {
            setOnclickPopups(popup);
        }

        let hidePopUps = function() {
            for(let popup of popups) {
                popup.classList.remove('active');
            }
        }
    }
}
</script>